import React, { useState } from "react";
import { firebase, cheq, db, database } from "../../firebaseConfig";
import { BrowserRouter as Link } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';


import FooterNew from "../../Footers/Footer";
import ClientDetails from "../components/clientDetails";
import Employee from "../components/employee";
import TnC from "../components/tnc";

import { Button } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import Checkbox from '@mui/material/Checkbox';
import Login from "../../Login";
import FooterNext from "../../Footers/FooterNext";
import SafeplanTermsAndConditions from "./descrptions/safeplanTermsAndConditions";
import DescriptionEmployeeHealthCheckup from "./descrptions/descrptionEmployeeHealthCheckup";

export default function EmployeeHealthCheckup(){
  // Inputs

  const [user] = useAuthState(cheq);

  const [todayDate, setTodayDate] = useState(new Date());
  const [reqDate, setReqDate] = useState(new Date());

  const booleanDiagnosticTest = { inputProps: { 'aria-label': 'diagnostic test' } };
  const booleanEyeCheckup = { inputProps: { 'aria-label': 'eye checkup' } };
  const booleanDentalCheckup = { inputProps: { 'aria-label': 'dental checkup' } };

  const [dt, setDT] = useState("0");
  const [ec, setEC] = useState("0");
  const [dc, setDC] = useState("0");

  const checkDiagnosticTest = () => {
    setDT(1-dt);
  }

  const checkEyeCheckup = () => {
    setEC(1-ec);
  }

  const checkDentalCheckup = () => {
    setDC(1-dc);
  }


  const [cityName, setCityName] = useState("");
  const [headCountMen, setHeadCountMen] = useState("");
  const [headCountWomen, setHeadCountWomen] = useState("");
  const [budgetPP, setBudgetPP] = useState("");

  const [otherInfo, setOtherInfo] = useState("");

  const [orgName, setOrgName] = useState("");
  const [orgRepName, setOrgRepName] = useState("");
  const [orgRepDesignation, setRepDesignation] = useState("");
  const [orgRepOfficialEmail, setOrgRepOfficialEmail] = useState("");
  const [orgCompleteAddress, setOrgCompleteAddress] = useState("");

  const cityOptions = [
    { label: 'Bengaluru' },
    { label: 'Delhi' },
    { label: 'Hyderabad' },
    { label: 'Mumbai' },
    { label: 'Pune' },
  ];

  const headCountOptions = [
    { label: 'less than 50' },
    { label: '50-100' },
    { label: '100-500' },
    { label: '500-1000' },
    { label: '1000-5000' },
    { label: 'more than 5000' },
  ];

  const budgetOptions = [
    { label: 'INR 200 - INR 500 per person' },
    { label: 'INR 500 - INR 1000 per person' },
    { label: 'INR 1000 - INR 1500 per person' },
    { label: 'INR 1500 - INR 2000 per person' },
    { label: 'INR 2000 - INR 2500 per person' },
    { label: 'above INR 2500 per person' },
  ];

  function postRequest() {

    if(cityName === ""){
      alert("Please enter City");
      return;
    }

    if(headCountMen === "" || headCountWomen === ""){
      alert("Please enter Head Count (Approx.)");
      return;
    }

    if(budgetPP === ""){
      alert("Please enter budget");
      return;
    }

    if(orgName === "" || orgRepName === "" || orgRepDesignation === "" || orgRepOfficialEmail === "" ||
    orgCompleteAddress === ""){
      alert("Please enter Organization Details");
      return;
    }

    db.collection("employee-safeplan").add({

      PosterPhone: cheq.currentUser.phoneNumber,
      city: cityName,
      headCountMen: headCountMen,
      headCountWomen: headCountWomen,
      budgetPP: budgetPP,


      booleanDiagnosticTest: dt,
      booleanEyeCheckup: ec,
      booleanDentalCheckup: dc,


      otherInfo: otherInfo,
      orgName: orgName,
      orgRepName: orgRepName,
      orgRepDesignation: orgRepDesignation,
      orgRepOfficialEmail: orgRepOfficialEmail,
      orgCompleteAddress: orgCompleteAddress,

      todayDate:todayDate, 
      requestDate: dayjs(reqDate).format('LL'),
      Time: firebase.firestore.Timestamp.now().toDate().toString(),
      
    });

    database.ref("onlinerequest/safeplan/employeehealthplans").push({

      PosterPhone: cheq.currentUser.phoneNumber,
      city: cityName,
      headCountMen: headCountMen,
      headCountWomen: headCountWomen,
      budgetPP: budgetPP,

      booleanDiagnosticTest: dt,
      booleanEyeCheckup: ec,
      booleanDentalCheckup: dc,

      otherInfo: otherInfo,
      orgName: orgName,
      orgRepName: orgRepName,
      orgRepDesignation: orgRepDesignation,
      orgRepOfficialEmail: orgRepOfficialEmail,
      orgCompleteAddress: orgCompleteAddress,

      todayDate:todayDate, 
      requestDate: dayjs(reqDate).format('LL'),
      Time: firebase.firestore.Timestamp.now().toDate().toString(),

    }).catch(alert);

    /*alert("dt - " + dt + "\n" +
    "ec - " + ec + "\n" + 
    "dc - " + dc );*/

    window.location.replace('https://rzp.io/l/drplanete-emp-health-chkp');
   
    //alert("Request Placed Successfully!!")
    /*alert("city Name - " + cityName + "\n" + headCount + "\n" + budgetPP + "\n" +
    orgName + "\n" + orgRepName + "\n" + orgRepDesignation + "\n" + orgRepOfficialEmail + "\n" + 
    orgCompleteAddress + "\n" + dayjs(todayDate).format('L') + "\n" + dayjs(reqDate).format('LL'));

    */
  }

  return (
    user ? <>
    
    {/*<div>
      <div><img
        className="w-full h-[440px] object-cover"
        style={{width:"1600px", height:"300px"}}
        src="https://firebasestorage.googleapis.com/v0/b/admin-5d27b.appspot.com/o/safeplan%2Fweb-heads%2Fweb%20-%20ehcp.png?alt=media&token=4db4a54d-4087-4f65-97b8-a6b81901df20"
        alt=""
      /></div>
      
      <div>
            <div class="container body-content" style={{ marginTop: "15px", marginBottom: "35px" }}>

                <div class="container body-content" style={{ marginBottom: "45px" }}>
                    <center><Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={cityOptions}
                        sx={{ width: 500 }}
                        onChange={(event, value) => setCityName(value.label)}
                        renderInput={(params) => <TextField {...params} label="Select City" />}
                    /></center>
                </div>

                <div class="border-1 border-indigo-600">
                    <div style={{ marginBottom: "15px" }}>
                        
                        <div
                            style={{ marginTop: "15px", marginLeft: "35px" }}
                        >
                            <div class="columns-2">
                                <center>
                                    <div style={{ marginTop: "15px" }}>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={headCountOptions}
                                            sx={{ width: 400 }}
                                            onChange={(event, value) => setHeadCountMen(value.label)}
                                            renderInput={(params) => <TextField {...params} label="Head Count (Men)" />}
                                        />
                                    </div>

                                    <div style={{ marginTop: "15px" }}>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={headCountOptions}
                                            sx={{ width: 400 }}
                                            onChange={(event, value) => setHeadCountWomen(value.label)}
                                            renderInput={(params) => <TextField {...params} label="Head Count (Women)" />}
                                        />
                                    </div>
                                </center>
                            </div>

                            <div style={{ marginTop: "15px" }}>
                                <center>
                                    <div><Checkbox {...booleanDiagnosticTest}  onChange={checkDiagnosticTest}/>Include Diagnostic Tests</div>
                                    <div><Checkbox {...booleanEyeCheckup} onChange={checkEyeCheckup}/>Include Eye checkup</div>
                                    <div><Checkbox {...booleanDentalCheckup} onChange={checkDentalCheckup}/>Include Dental checkup</div>
                                </center>
                            </div>

                            
                            <div class="columns-1" style={{ marginTop: "15px" }}>
                                <center>
                                    <div style={{ marginBottom: "15px" }}>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={budgetOptions}
                                            sx={{ width: 700 }}
                                            onChange={(event, value) => setBudgetPP(value.label)}
                                            renderInput={(params) => <TextField {...params} label="Approx Budget per Person" />}
                                        />
                                    </div>

                                    <div style={{ marginTop: "15px" }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                                            <DatePicker
                                                renderInput={(props) => <TextField {...props} />}
                                                label="Date"
                                                style={{ width: "1000px" }}
                                                value={reqDate}
                                                onChange={(newValue) => {
                                                    setReqDate(newValue);
                                                }}
                                            />
                                        </LocalizationProvider>
                                        <p>You selected {dayjs(reqDate).format('LL')}</p>
                                    </div>
                                    <div style={{ marginTop: "15px", marginBottom: "15px" }}>
            <TextField id="outlined-basic"
              multiline fullWidth
              maxRows={4}
              label="Any other info" variant="outlined" onChange={(e) => setOtherInfo(e.target.value)}/>
          </div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <div >

        <div class="container body-content border-1 border-indigo-600" style={{ marginTop: "15px", marginBottom: "35px" }}>
          <div style={{ marginTop: "35px", marginBottom: "15px", width: "450px" }}>
            <TextField id="outlined-basic" fullWidth label="Organization Name" variant="outlined"  onChange={(e) => setOrgName(e.target.value)}/>
          </div>
          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic" fullWidth label="Organization Representative Name" variant="outlined" onChange={(e) => setOrgRepName(e.target.value)} />
          </div>
          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic" fullWidth label="Organization Representative Designation" variant="outlined" onChange={(e) => setRepDesignation(e.target.value)}/>
          </div>

          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic" fullWidth label="Representative Official Email ID" variant="outlined" onChange={(e) => setOrgRepOfficialEmail(e.target.value)}/>
          </div>
          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic"
              multiline fullWidth
              maxRows={4}
              label="Organization Address" variant="outlined" onChange={(e) => setOrgCompleteAddress(e.target.value)}/>
          </div>

        </div>
      </div>

      <div>
      <center>
              <Button variant="primary" size="lg" onClick={postRequest}>Post Request</Button>
            </center>

            </div>
      <div><FooterNext/></div>
    </div> */}
<div>

  <DescriptionEmployeeHealthCheckup/>
<div className="ehcp-container">
      <style>{`
        .ehcp-container {
          background-color: white;
          font-family: sans-serif;
          padding: 16px;
        }
        .ehcp-image {
          width: 100%;
          height: auto;
          max-height: 300px;
          object-fit: cover;
        }
        .ehcp-section {
          max-width: 800px;
          margin: 0 auto 40px auto;
          padding: 0 16px;
        }
        .ehcp-field {
          margin: 20px 0;
          width: 100%;
        }
        .ehcp-checkbox-group {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
          margin: 20px 0;
        }
        .ehcp-button {
          margin-top: 30px;
        }
        @media (min-width: 768px) {
          .ehcp-checkbox-group {
            flex-direction: row;
            align-items: center;
          }
        }
      `}</style>

      <div className="ehcp-section">
        <Autocomplete
          disablePortal
          options={cityOptions}
          onChange={(event, value) => setCityName(value?.label)}
          renderInput={(params) => <TextField {...params} label="Select City" />}
          className="ehcp-field"
        />

        <Autocomplete
          disablePortal
          options={headCountOptions}
          onChange={(event, value) => setHeadCountMen(value?.label)}
          renderInput={(params) => <TextField {...params} label="Head Count (Men)" />}
          className="ehcp-field"
        />

        <Autocomplete
          disablePortal
          options={headCountOptions}
          onChange={(event, value) => setHeadCountWomen(value?.label)}
          renderInput={(params) => <TextField {...params} label="Head Count (Women)" />}
          className="ehcp-field"
        />

        <div className="ehcp-checkbox-group">
          <label><Checkbox {...booleanDiagnosticTest} onChange={checkDiagnosticTest} />Include Diagnostic Tests</label>
          <label><Checkbox {...booleanEyeCheckup} onChange={checkEyeCheckup} />Include Eye Checkup</label>
          <label><Checkbox {...booleanDentalCheckup} onChange={checkDentalCheckup} />Include Dental Checkup</label>
        </div>

        <Autocomplete
          disablePortal
          options={budgetOptions}
          onChange={(event, value) => setBudgetPP(value?.label)}
          renderInput={(params) => <TextField {...params} label="Approx Budget per Person" />}
          className="ehcp-field"
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Preferred Date"
            value={reqDate}
            onChange={(newValue) => setReqDate(newValue)}
            renderInput={(props) => <TextField {...props} className="ehcp-field" />}
          />
        </LocalizationProvider>

        <p>You selected: {dayjs(reqDate).format('LL')}</p>

        <TextField
          multiline
          maxRows={4}
          fullWidth
          label="Any other info"
          variant="outlined"
          className="ehcp-field"
          onChange={(e) => setOtherInfo(e.target.value)}
        />
      </div>

      <div className="ehcp-section">
        <TextField
          fullWidth
          label="Organization Name"
          variant="outlined"
          className="ehcp-field"
          onChange={(e) => setOrgName(e.target.value)}
        />
        <TextField
          fullWidth
          label="Organization Representative Name"
          variant="outlined"
          className="ehcp-field"
          onChange={(e) => setOrgRepName(e.target.value)}
        />
        <TextField
          fullWidth
          label="Representative Designation"
          variant="outlined"
          className="ehcp-field"
          onChange={(e) => setRepDesignation(e.target.value)}
        />
        <TextField
          fullWidth
          label="Representative Official Email ID"
          variant="outlined"
          className="ehcp-field"
          onChange={(e) => setOrgRepOfficialEmail(e.target.value)}
        />
        <TextField
          fullWidth
          multiline
          maxRows={4}
          label="Organization Address"
          variant="outlined"
          className="ehcp-field"
          onChange={(e) => setOrgCompleteAddress(e.target.value)}
        />
      </div>

      <SafeplanTermsAndConditions/>
      <div>
            <center>
            <Button variant="primary" size="lg" onClick={postRequest}>Post Request</Button>         
            </center>
            </div>


    </div>

    <FooterNext/>
    </div>
    
    </> : <Login/>
  );
}
